import React, { useEffect, useState } from 'react'
import { ICreateExpenseData, IVendor } from '../../../../@types';
import { CloseIcon } from '../../../../assets/icons';
import { InfoCircle } from '../../../../assets/icons/InfoCircle';
import PlusBoxIcon from '../../../../assets/icons/PlusBoxIcon';
import { EXPENSE_CATEGORY, EXPENSE_PAYMENT_CURRENCY_LIST, PAYMENT_PROVIDER_LIST } from '../../../../constants';
import { useVendorSearch } from '../../../../hooks';
import useLineItems from '../../../../modules/lineItem';
import { SearchInput } from '../../../common';
import { MiniCard } from '../../../common/TooltipCards/miniCards';
import { DropdownComponent, InputComponent } from '../../../core/Forms';
import { AddVendors } from '../../../vendors/Addvendor';


interface ExpenseDetailProps {
  handleInputChange: (event: { target: { name: any; value: any } }) => void;
  validationResults: ICreateExpenseData
  formData:  ICreateExpenseData;
  setFormData:React.Dispatch<React.SetStateAction< ICreateExpenseData>>;
  handleDropDownChange: (name: string, value: string) => void; 
  handleSelectedVendor :(selectedVendor: IVendor | null) => void;
  validateCurrentStep: () => boolean;
  expense: ICreateExpenseData;
  showRateInput: boolean;
  vendorName:IVendor | undefined;
  selectedCurrencyLabel: string;
}
  const ExpenseDetail: React.FC<ExpenseDetailProps> = ({
    handleInputChange,
    validationResults,
    formData, 
    setFormData, 
    handleDropDownChange,
    validateCurrentStep,
    expense,
    showRateInput,
    handleSelectedVendor,
    vendorName,
    selectedCurrencyLabel,
  }) => {

    const dropDownCategory = EXPENSE_CATEGORY;
    const dropDownCurrency = EXPENSE_PAYMENT_CURRENCY_LIST;
    const dropDownPaymentMethod = PAYMENT_PROVIDER_LIST;
    const { data: vendors, isSearching: isVendorSearching, handleSearch: handleVendorSearch } = useVendorSearch();
    const [showNewCustomerModal, setShowNewVendorModal] = React.useState<boolean>(false);
    const [, setVendorName] = React.useState<IVendor | undefined>();
    const [currencyRate, setCurrencyRate] = useState('');
    const [isMiniCardVendorVisible, setIsMiniCardVendorVisible] = useState(false);
    const [, setValidationResults] = React.useState<ICreateExpenseData>({
      customerId: '',
      date: '',
      lineItems: [],
      category: '',
      currency: '',
      description: '',
   isBillable: false,
      vendorName: '',
      amount: 0,
      paymentMethod: '',
      exchangeRate:0,
    });

    const { items, addItem, setItems, removeItem, updateCell, updateRow } = useLineItems([expense?.lineItems.length ? expense?.lineItems : { id: '', name: '', rate: 0, quantity: 0 }]);
    console.log(formData.currency)

    useEffect(() => {
      if (expense) {
        console.log('Fetched expense:', expense);
        setFormData((prevState) => ({
          ...prevState,
           notes: expense.notes,
          customerId: expense.customerId,
          customerName: expense.customerName,
          vendorName: expense.vendorName,
           amount: expense.amount,
          description: expense.description,
          paymentMethod: expense.paymentMethod,
           lineItems: expense.lineItems,
          currency: expense.currency,
          category: expense.category,
           isBillable:expense.isBillable,
       
        }));
    
        const newItems = expense.lineItems.map((lineItem: any) => ({
          id: lineItem.id,
          name: lineItem.name,
          quantity: lineItem.quantity,
          rate: parseFloat(lineItem.rate)
        }));
        
        setItems(newItems);
    
        handleSelectedVendor({
          name: expense.vendorName as string,
          id: expense.vendorId as string
        });
      }
    }, [expense]);

    const handleInfoCircleHover = () => {
      setIsMiniCardVendorVisible(true);
    };
  
    const handleInfoCircleMouseLeave = () => {
      setIsMiniCardVendorVisible(false);
    };


return (
  <div className=" ">
    <h2 className="text-center xl:text-[24px] mt-[1em] mb-[5px] lg:mb-0 md:mb-0">Please fill in the required information needed to begin.</h2>
    <form className="flex justify-center">
      <div className="ml-[-0.6em] 360:ml-[-1.9em] 375:ml-[-0.9em]">
        <div className=" lg:grid lg:grid-cols-2 md:grid md:grid-cols-2 xl:gap-[28px] biglg:gap-[30px] lg:gap-[36px] bigmd:mt-[32px] md:mt-[32px] xl:mt-[32px] biglg:mt-[32px] lg:mt-[32px]">
          <div className="ml-[5.5em] 375:ml-[4.1em] 360:ml-[5.2em] lg:ml-0 xl:ml-0 2xl:ml-0 biglg:ml-0 bigmd:ml-0 md:ml-0 mt-[32px] lg:mt-0 xl:mt-0 2xl:mt-0 biglg:mt-0 bigmd:mt-0 md:mt-0 ">
            <label
              htmlFor="customer"
              className=" inline-flex  text-[12px] xl:text-[13px]  ml-[-3.4em] md:ml-[-2em] lg:ml-[2.9em] xl:ml-[8.9em] 375:ml-[-3.8em] 360:ml-[-3.8em]"
              style={{ whiteSpace: 'nowrap' }}
            >
             Expense Title 
            </label>
              <InputComponent
                  type="text"
                  className="w-[350px] md:w-[320px] ml-[-3em] border border-gray-300 bg-white max-h-[48px] min-h-[48px] placeholder:text-[15.25px] rounded  focus:outline-none focus:shadow-outline appearance-none focus:ring-0 leading-normal md:ml-[-1.8em] lg:ml-[2em] xl:ml-[7em] xl:w-[434px]"
                  placeholder="Expense Title"
                  value={formData.description}
                  name="description"
                  handleChange={handleInputChange}
                  error={validationResults.description}
                />
          </div>
          <div className="mt-[13px] lg:mt-0 xl:mt-0 2xl:mt-0 biglg:mt-0 bigmd:mt-0 md:mt-0 ml-[1.9em] 375:ml-[1.1em] 360:ml-[2.2em] ">
            <label htmlFor="invoiceNo" className="text-[12px] xl:text-[13px] biglg:mt-[em]  xl:mt-0 lg:mt-[-0.7em]">
            Expense Date
            </label>
            <div className="xl:mt-[0em] biglg:mt-[0.1em] lg:mt-[0.15em] bigmd:mt-[-0.4em] md:mt-[-0.4em]">
               <InputComponent
                  type="date"
                  className="w-[350px] md:w-[320px] xl:w-[434px] rounded-[4px]  border-1 border-[#A4A4A4] placeholder:text-[#A4A4A4] text-sm font-medium bg-gray-100 appearance-none disabled:opacity-50 disabled:bg-gray-700  max-h-[48px] min-h-[48px]   "
                  placeholder="Expense Date"
                  value={formData.date}
                  name="date"
                  handleChange={handleInputChange}
                  restrictFutureDates={true}
                  error={validationResults.date}
                />
            </div>
          </div>
        </div>

        <div className="lg:grid lg:grid-cols-2 md:grid md:grid-cols-2  md:mt-[52px] xl:gap-[28px] lg:gap-[36px] bigmd:mt-[38px] lg:mt-[38px] biglg:gap-[30px] biglg:mt-[38px] xl:mt-[38px]">
          <div className="ml-[4.2em] 375:ml-[4.1em] 360:ml-[5.2em] lg:ml-0 xl:ml-0 2xl:ml-0 biglg:ml-0 bigmd:ml-1 md:ml-0 mt-[13px] lg:mt-0 xl:mt-0 2xl:mt-0 biglg:mt-0 bigmd:mt-0 md:mt-0">
            <label
              htmlFor="issueDate"
              className="block text-[12px] xl:ml-[8.9em] xl:text-[13px] ml-[-3.7em] md:ml-[-2.2em] biglg:ml-[2.6em] lg:ml-[2.9em]  375:ml-[-4em]"
              style={{ whiteSpace: 'nowrap' }}
            >
            Reference ID
            </label>
              <InputComponent
                  type="text"
                  className="w-[350px]  md:w-[320px] ml-[-3em] border border-gray-300 bg-white max-h-[48px] min-h-[48px] placeholder:text-[15.25px] rounded  focus:outline-none focus:shadow-outline appearance-none focus:ring-0 leading-normal md:ml-[-1.8em] lg:ml-[2em] xl:ml-[7em] xl:w-[434px]"
                  placeholder="Reference#"
                  value={formData.reference}
                  name="reference"
                  handleChange={handleInputChange}
                />
          </div>
          <div className="mt-[13px] 375:ml-[1.1em] 360:ml-[2.2em]  lg:mt-0 xl:mt-0 2xl:mt-0 biglg:mt-0 bigmd:mt-0 md:mt-0 ml-[1.9em]">
            <label htmlFor="invoiceDueAt" className="xl:text-[13px] text-[12px] xl:mt-0 biglg:mt-[-1em]">
            Category
              <span className="text-red-500 ml-[17em] md:ml-[17.5em] bigmd:ml-[17em] lg:ml-[17.2em] xl:ml-[23.9em] 375:ml-[19.8em] 360:ml-[20em]">
                **Required
              </span>
            </label>
            <div className="xl:mt-[0.1em] biglg:mt-[-0.1em] lg:mt-[-0.1em] md:mt-[-0.3em]">
                <DropdownComponent
                  name="category"
                  options={dropDownCategory}
                  value={formData.category}
                  placeholder="Category"
                  selectedValue={formData.category}
                  onChange={handleDropDownChange}
                  dropdownClassName="w-[350px] md:w-[320px] xl:w-[434px] rounded-[4px] placeholder:text-[#A4A4A4] border-1 border-[#A4A4A4] "
                  iconClassName="ml-[9em] md:mr-[1em] xl:mr-[7em] lg:mr-[1.1em] biglg:mr-[2.5em] 360:mr-[1em] 375:mr-[1em] bigmd:mr-[1em] 2xl:mr-[7em]"
                />
              <div className="ml-[0.1em] md:ml-[0.1em] md:mt-[0.5em] biglg:ml-[0.2em] lg:ml-[0.5em] xl:ml-[0.5em] xl:mt-[em]">
                {(validationResults.category) && (
                  <span className="text-red-500" style={{ whiteSpace: 'nowrap', padding: '0', lineHeight: '1.2' }}>
                    {validationResults.category}
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
      <div className=" lg:grid lg:grid-cols-2 md:grid md:grid-cols-2 xl:gap-[28px] biglg:gap-[30px] lg:gap-[36px] bigmd:mt-[32px] md:mt-[32px] xl:mt-[32px] biglg:mt-[32px] lg:mt-[32px]">
            <div className="375:ml-[4.2em] 360:ml-[5.2em] lg:ml-0 xl:ml-0 2xl:ml-0 biglg:ml-0 bigmd:ml-0 md:ml-0 mt-[28px] 540:mt-[1em] lg:mt-0 xl:mt-0 2xl:mt-0 biglg:mt-0 bigmd:mt-0 md:mt-0">
              <label
                htmlFor="customer"
                className=" inline-flex  text-[12px] xl:text-[13px]  ml-[-3.4em] md:ml-[-2em] lg:ml-[2.9em] xl:ml-[8.9em] 375:ml-[-3.8em] 360:ml-[-3.8em]"
                style={{ whiteSpace: 'nowrap' }}
              >
                Vendor Name
                <div
                  className="relative hidden lg:block"
                  onMouseEnter={handleInfoCircleHover}
                  onMouseLeave={handleInfoCircleMouseLeave}
                >
                  {isMiniCardVendorVisible ? (
                    <div className="absolute z-10 mt-[6em] ml-[-9em]">
                      <MiniCard
                        text1="Click Add New Vendor to add a new vendor by"
                        text2="filling all required information on the form."
                        icon={<InfoCircle />}
                      />
                    </div>
                  ) : (
                    <div className='mt-[0.3em]'>
                    <InfoCircle />
                    </div>
                  )}
                </div>
                <span className="text-red-500 ml-[14em]   xl:ml-[20.5em] lg:ml-[13.5em] biglg:ml-[13.8em] md:ml-[12.2em] 375:ml-[17.3em] 360:ml-[17.6em] 540:ml-[17.5em]">
                  **Required
                </span>
              </label>
              <SearchInput
                placeholder="Search for Vendor"
                data={vendors}
                displayKey="name"
              
                isLoading={isVendorSearching}
                value={formData.vendorName}
                selected={vendorName}
              onSelect={handleSelectedVendor}
              handleChangeText={handleVendorSearch}
              emptyMessage={'This vendor is not found'}
                clearIcon={CloseIcon}
                clearIconClass="xl:mr-[1em] mr-[0.5em] md:mr-[2.2em] biglg:mr-[2em]"
                classNames="w-[350px]  md:w-[320px] ml-[-3em] border border-gray-300 bg-white max-h-[48px] min-h-[48px] placeholder:text-[15.25px] rounded  focus:outline-none focus:shadow-outline appearance-none focus:ring-0 leading-normal md:ml-[-1.8em] lg:ml-[2em] xl:ml-[7em] xl:w-[434px]"
                error={validationResults.vendorName}
                dropdownClassName="w-[350px] md:w-[320px] ml-[-3em] md:ml-[-1.7em] lg:ml-[2em] xl:ml-[7em] xl:w-[434px]"
                dropdownStyle={{
                  maxHeight: '800px',
                  overflowY: 'auto',
                }}
              />
              <a
                href="#customer-modal"
                className="inline-flex items-center lg:text-[16px] text-[12px] text-[#044E97] font-medium mt-[-1rem] ml-[-3.9em] md:ml-[-2em] lg:ml-[2.2em] xl:ml-[7.2em] biglg:ml-[2.2em]"
                onClick={() => setShowNewVendorModal(true)}
              >
                New Vendor
                <PlusBoxIcon />
              </a>
              <div className="mt-[-0.5em] ml-[-2.8em] md:ml-[-1.6em] lg:ml-[2em] xl:mt-[-0.5em] xl:ml-[7em]">
                {(validationResults.vendorName) && (
                  <span className="text-red-500">
                    {validationResults.vendorName}
                  </span>
                )}
              </div>
           </div>
                 <div className="mt-[13px] 375:ml-[1.2em] 360:ml-[2.2em] lg:mt-0 xl:mt-0 2xl:mt-0 biglg:mt-0 bigmd:mt-0 md:mt-0 xl:ml-[] ml-[1.9em] ">
            <label htmlFor="invoiceDueAt" className="xl:text-[13px] text-[12px] xl:mt-0 lg:mt-[-0.7em]" style={{ whiteSpace: 'nowrap' }}>
          Payment Method
              <span className="text-red-500 ml-[17em] md:ml-[17.5em] bigmd:ml-[17em] lg:ml-[13.7em] biglg:ml-[13.7em] xl:ml-[20.4em] 375:ml-[16.3em] 360:ml-[16.3em] 540:ml-[16em]">
                **Required
              </span>
            </label>
            <div className="xl:mt-[0.1em] biglg:mt-[-0.1em] lg:mt-[0.1em] md:mt-[-0.3em]">
                 <DropdownComponent
                  name={'paymentMethod'}
                  options={dropDownPaymentMethod}
                  placeholder="Payment Method"
                  selectedValue={formData.paymentMethod?.toUpperCase()}
                  onChange={handleDropDownChange}
                  dropdownClassName="w-[350px] md:w-[320px] xl:w-[434px] rounded-[4px] placeholder:text-[#A4A4A4] border-1 border-[#A4A4A4]"
                  iconClassName="mr-[4em] md:mr-[1em] xl:mr-[7em] lg:mr-[1.1em] biglg:mr-[2.5em] 375:mr-[1em] bigmd:mr-[1em] 2xl:mr-[7em] 360:mr-[1em] "
                />
              <div className="ml-[0.1em] md:ml-[0.1em] md:mt-[0.5em] biglg:ml-[0.2em] lg:ml-[0.5em] xl:ml-[0.5em] xl:mt-[em] ">
                {(validationResults.paymentMethod) && (
                  <span className="text-red-500" style={{ whiteSpace: 'nowrap', padding: '0', lineHeight: '1.2' }}>
                    {validationResults.paymentMethod}
                  </span>
                )}
              </div>
            </div>
          </div>
            </div>
                <div className="lg:flex lg:justify-left md:flex md:justify-left md:mt-[36px] bigmd:mt-[32px] xl:gap-[24px] xl:mt-[32px] lg:gap-[36px] lg:mt-[32px]  biglg:gap-[22px] biglg:mt-[32px] xl:ml-[0.2em]">
                <div className=" 375:ml-[4.1em] 360:ml-[5.1em] lg:ml-0 xl:ml-0 2xl:ml-0 biglg:ml-0 bigmd:ml-0 md:ml-0 mt-[13px] lg:mt-0 xl:mt-0 2xl:mt-0 biglg:mt-0 bigmd:mt-0 md:mt-0">
                  <label
                    htmlFor="Currency"
                    className="inline-flex text-[12px] xl:text-[13px] ml-[-3.4em] md:ml-[-2.5em] lg:ml-[2.8em] xl:ml-[8.5em] 375:ml-[-3.9em]"
                  >
                    Select Currency
                  </label>
                  <DropdownComponent
                    name="currency"
                    options={dropDownCurrency}
                    value={formData.currency}
                    placeholder="Select Currency"
                    selectedValue={selectedCurrencyLabel}
                    onChange={(name, value) => handleDropDownChange(name, value)}
                    dropdownClassName="w-[350px]  md:w-[320px] ml-[-3em] border border-gray-300 bg-white md:ml-[-1.8em] lg:ml-[2em] xl:ml-[6.7em] xl:w-[434px]"
                    iconClassName="mr-[4em] md:mr-[1em] xl:ml-[-1.5em] lg:mr-[1.1em] biglg:mr-[1em] 375:mr-[1em] 360:mr-[0.9em]  bigmd:mr-[1em] 2xl:mr-[1em]"
                  />
                  <div className="ml-[-3em] md:ml-[-2em] bigmd:ml-[-1.7em] lg:ml-[2.2em] xl:ml-[7em] ">
                    {(validationResults.currency) && (
                      <span className="text-red-500" style={{ whiteSpace: 'nowrap', padding: '0', lineHeight: '1.2' }}>
                        {validationResults.currency}
                      </span>
                    )}
                  </div>
                </div>
            </div>
</div>
</form>
    <AddVendors
            show={showNewCustomerModal}
            onClose={() => setShowNewVendorModal(false)}
            onVendorCreate={handleSelectedVendor}
          />
  </div>
);
};

export default ExpenseDetail;

  
